<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4 class="mb-4">Atenciones Finalizadas sin Diagnóstico</h4>
    <hr>

    <!--  Botones de rango rápido  -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-outline-primary"   @click="setDateRange(getToday)">Hoy</button>
      <button class="btn btn-outline-secondary" @click="setDateRange(getThisMonth)">Mes Actual</button>
      <button class="btn btn-outline-success"   @click="setDateRange(getThisQuarter)">Trimestre Actual</button>
      <button class="btn btn-outline-info"      @click="setDateRange(getThisSemester)">Semestre Actual</button>
      <button class="btn btn-outline-warning"   @click="setDateRange(getThisYear)">Año Actual</button>
    </div>

<!--  Selector de fechas  -->
<div class="fecha-bar mb-3">
  <div class="fecha-campo">
    <label class="form-label">Desde</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaDesde">
  </div>
  <div class="fecha-campo">
    <label class="form-label">Hasta</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaHasta">
  </div>
  <button class="btn btn-dark btn-icono" @click="fetchAtencionesSinDiagnostico()">
    <span class="material-symbols-outlined">search</span>
    Consultar
  </button>
</div>

    <!--  DataTable  -->
    <DataTable
      :data="atenciones"
      :columns="columnas"
      idField="idAtencion"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay atenciones finalizadas sin diagnóstico para el rango seleccionado."
      @refresh="fetchAtencionesSinDiagnostico()"
    >
      <template #cell-fechaCita="{ row }">
        {{ getFormattedDate(row.fechaCita) }}
      </template>

      <template #cell-estadoAtencion="{ row }">
        <span class="badge-estado" :class="getClassForEstadoAtencion(row.estadoAtencion)">
          {{ row.estadoAtencion }}
        </span>
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import Swal       from 'sweetalert2'
import {
  getToday, getThisMonth, getThisQuarter,
  getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

export default {
  name: 'AtencionesSinDiagnostico',
  components: { Layout, Footer, DataTable },

  data() {
    return {
      fechaDesde: '',
      fechaHasta: '',
      atenciones: [],

      getToday, getThisMonth, getThisQuarter,
      getThisSemester, getThisYear,

      columnas: [
        { field: 'idAtencion',          label: 'ID Atención' },
        { field: 'fechaCita',           label: 'Fecha Cita' },
        { field: 'horaDesde',           label: 'Hora Desde' },
        { field: 'horaHasta',           label: 'Hora Hasta' },
        { field: 'nombrePaciente',      label: 'Nombre Paciente' },
        { field: 'documentoPaciente',   label: 'Documento' },
        { field: 'nombreMedico',        label: 'Nombre Médico' },
        { field: 'nombreEspecialidad',  label: 'Especialidad' },
        { field: 'motivo',              label: 'Motivo' },
        { field: 'estadoAtencion',      label: 'Estado Atención' },
      ],
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    setDateRange(getRangeFunction) {
      const { fechaDesde, fechaHasta } = getRangeFunction()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.fetchAtencionesSinDiagnostico()
    },

    validarFechas() {
      if (!this.fechaDesde || !this.fechaHasta) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos requeridos',
          text: 'Debe seleccionar las fechas desde y hasta.',
          confirmButtonText: 'Aceptar',
        })
        return false
      }
      return true
    },

    fetchAtencionesSinDiagnostico() {
      if (!this.validarFechas()) return
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get('/vwatencions/finalizadas-sin-diagnostico', {
        params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
      })
      .then(response => { this.atenciones = response.data })
      .catch(error   => console.error('Error fetching atenciones:', error))
    },

    getClassForEstadoAtencion(estado) {
      return {
        'PENDIENTE':          'pendiente',
        'PROCESO':            'proceso',
        'FINALIZADA':         'finalizada',
        'PLANILLA GENERADA':  'planilla-generada',
        'FACTURADA':          'facturada',
      }[estado] || ''
    },
  },
}
</script>

<style src="@/assets/css/fechaBar.css" scoped></style>
<style scoped>
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}
.pendiente         { background-color: #ffc107; }
.proceso           { background-color: #17a2b8; color: #fff; }
.finalizada        { background-color: #28a745; color: #fff; }
.planilla-generada { background-color: #6c757d; color: #fff; }
.facturada         { background-color: #007bff; color: #fff; }
</style>